import { WSFilter } from "@wingspanhq/fe-component-library";
import { TransactionType } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { queriesTransactionCategories } from "@query";

export const TYPE_FILTER_ALL = "All";

const TYPE_OPTIONS: { name: TransactionType; label: string }[] = [
  { name: TransactionType.EXPENSE, label: "Expense" },
  { name: TransactionType.INCOME, label: "Income" },
  { name: TransactionType.TRANSFER, label: "Transfer" },
  { name: TransactionType.REFUND, label: "Refund" },
  { name: TransactionType.FEE, label: "Fee" },
  { name: TransactionType.REWARD, label: "Reward" }
];

export function useTransactionsFiltersConfig(): WSFilter[] {
  const queryCategories =
    queriesTransactionCategories.listTransactionCategories.useQuery();

  const categoryOptions = useMemo(
    () =>
      (queryCategories.data?.data ?? []).map(category => ({
        name: category.name,
        label: category.name
      })),
    [queryCategories.data]
  );

  return useMemo(
    (): WSFilter[] => [
      {
        title: "Type",
        name: "type",
        type: "radio",
        titleInLabel: true,
        options: [
          { name: TYPE_FILTER_ALL, label: "All", hidePill: true },
          ...TYPE_OPTIONS
        ]
      },
      {
        title: "Category",
        name: "category",
        type: "select",
        searchable: true,
        titleInLabel: true,
        options: categoryOptions
      }
    ],
    [categoryOptions]
  );
}
